import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicketAlt, faUserShield, faSignInAlt, faUserPlus, faRocket, faChartLine, faClock } from '@fortawesome/free-solid-svg-icons';
import './Home.css';

const Home: React.FC = () => {
  const { isAuthenticated, isAdmin } = useContext(AuthContext);
  
  useEffect(() => {
    document.title = 'Nodesail Support Center';
  }, []);
  
  return (
    <div className="container">
      <div className="row justify-content-center text-center">
        <div className="col-md-10">
          <div className="my-5">
            <h1 className="display-4 fw-bold mb-2">Nodesail Support Center</h1>
            <p className="lead mb-4 welcome-text">
              Get help with your issues quickly and easily. Our dedicated support team is here to assist you.
            </p>
            
            {!isAuthenticated ? (
              <div className="d-grid gap-3 d-sm-flex justify-content-sm-center mb-5">
                <Link to="/login" className="btn btn-primary btn-lg px-4 gap-3 shadow-sm">
                  <FontAwesomeIcon icon={faSignInAlt} className="me-2" />
                  Login
                </Link>
                <Link to="/register" className="register-btn btn btn-outline-secondary btn-lg px-4 shadow-sm">
                  <FontAwesomeIcon icon={faUserPlus} className="me-2" />
                  Register
                </Link>
              </div>
            ) : (
              <div className="d-grid gap-3 d-sm-flex justify-content-sm-center mb-5">
                {isAdmin ? (
                  <Link to="/admin" className="btn btn-primary btn-lg px-4 gap-3 shadow-sm">
                    <FontAwesomeIcon icon={faUserShield} className="me-2" />
                    Admin Dashboard
                  </Link>
                ) : (
                  <Link to="/tickets/new" className="btn btn-primary btn-lg px-4 gap-3 shadow-sm">
                    <FontAwesomeIcon icon={faTicketAlt} className="me-2" />
                    Create a Ticket
                  </Link>
                )}
                <Link to="/dashboard" className="register-btn btn btn-outline-secondary btn-lg px-4 shadow-sm">
                  My Tickets
                </Link>
              </div>
            )}
          </div>
          
          <hr className="my-5" />
          
          <div className="row g-4 py-5">
            <div className="col-md-4">
              <div className="card h-100 shadow">
                <div className="card-body text-center p-4">
                  <FontAwesomeIcon icon={faRocket} size="2x" className="text-primary mb-3" />
                  <h3 className="card-title h4">Quick Support</h3>
                  <p className="card-text">Get fast responses from our support team for all your issues.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 shadow">
                <div className="card-body text-center p-4">
                  <FontAwesomeIcon icon={faChartLine} size="2x" className="text-primary mb-3" />
                  <h3 className="card-title h4">Track Progress</h3>
                  <p className="card-text">Easily track the status and updates of your support tickets.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 shadow">
                <div className="card-body text-center p-4">
                  <FontAwesomeIcon icon={faClock} size="2x" className="text-primary mb-3" />
                  <h3 className="card-title h4">Always Available</h3>
                  <p className="card-text">Our support platform is accessible 24/7 for your convenience.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;